<script>
	import SpecColumns from './SpecColumns.svelte'
	import SpecRow from './SpecRow.svelte'
	import ModelImage from './ModelImage.svelte'
	import SkeletonImage from './SkeletonImage.svelte';
	import PlusIcon from "./icons/PlusIcon.svelte";

  import models, { hasValueByType } from './../stores/models';

	export let imagePlaceholder = '';
	export let showLoader = false;

	const specsList = [
		{ type: 'accel_0_100', title: '0 - 100 км/ч'},
		{ type: 'accel_0_200', title: '0 - 200 км/ч'},
		{ type: 'accel_0_250', title: '0 - 250 км/ч'},
		{ type: 'accel_0_300', title: '0 - 300 км/ч'},
		{ type: 'brake_100_0', title: '100 км/ч - 0'},
		{ type: 'brake_200_0', title: '200 км/ч - 0'},
		{ type: 'time_402m', title: '1/4 мили' },
		{ type: 'time_1000m', title: '1000 м.' },
		{ type: 'top_speed', title: 'Макс. скорость' },
		{ type: 'introduced', title: 'Год выпуска' },
		{ type: 'engine_type', title: 'Двигатель' },
		{ type: 'displacement', title: 'Объем' },
		{ type: 'power', title: 'Мощность' },
		{ type: 'power_liter', title: 'Мощность / литр' },
		{ type: 'power_weight', title: 'Мощность / вес' },
		{ type: 'torque', title: 'Крутящий момент' },
		{ type: 'torque_weight', title: 'Крутящий момент / Вес' },
		{ type: 'transmission', title: 'Трансмиссия' },
		{ type: 'curb_weight', title: 'Снаряжённая масса' },
		{ type: 'efficiency', title: 'Эффективность' },
		{ type: 'noise_idle', title: 'Шум холостого хода' },
		{ type: 'emissions', title: 'Выбросы' },
		{ type: 'car_type', title: 'Кузов' },
		{ type: 'car_layout', title: 'Привод' },
		{ type: 'generation', title: 'Поколение' },
		{ type: 'dimensions', title: 'Размеры' },
		{ type: 'wheelbase', title: 'Колесная база' },
		{ type: 'origin_country', title: 'Страна' },
		{ type: 'years_built', title: 'Выпускалась' },
		{ type: 'eur_price', title: 'Цена в Европе' },
		{ type: 'us_price', title: 'Цена в США' },
		{ type: 'power_5000', title: 'Мощность / €5000' }
	];
</script>

<div class="specs-modal__pictures">
	{#if imagePlaceholder}
		<ModelImage src={imagePlaceholder} />
	{:else if !$models.length}
    <SkeletonImage />
	{:else}
		<SpecColumns type='img_url' {showLoader} />
	{/if}

  <div on:click class="rounded specs-modal__img-plug add-spec">
		<PlusIcon className="add-spec" />
  </div>
</div>

{#if !imagePlaceholder && !$models.length}
	<div class="mt-4 text-center specs-modal__skeleton-text">
		Выберите авто для сравнения
	</div>
{/if}

<div class="specs-modal__titles">
	<SpecColumns type='title' />
</div>

{#each specsList as {type, title, hide_empty}, i}
	{#if hasValueByType($models, type)}
		<SpecRow
			{type}
			{title}
			showDivider={i !== specsList.length - 1}
		/>
	{/if}
{/each}

<style lang="scss">
  .specs-modal__pictures,
	.specs-modal__titles {
		padding-left: 0;

		@media (min-width: 992px) {
			padding-left: 235px;
		}
	}

	.specs-modal__pictures {
		display: flex;
	}

	.specs-modal__titles {
		display: flex;
		margin-bottom: 10px;
	}

	.specs-modal__img-plug {
		min-width: 130px;
		min-height: 107px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		background: #e9ecef;
		transition: all .15s ease-in-out;
		text-align: center;

		@media (min-width: 576px) {
			min-width: 220px;
			min-height: 181px;
		}
	}

	.specs-modal__img-plug:hover {
		background: #d3d7dc;
	}

	.specs-modal__skeleton-text {
		width: 136px;

		@media (min-width: 576px) {
			margin-left: -10px;
			width: 240px;
		}

		@media (min-width: 992px) {
			margin-left: 230px;
			width: 230px;
		}
	}
</style>